import { render, staticRenderFns } from "./ipasasJaPermissionsSearch.vue?vue&type=template&id=5e685180&"
import script from "./ipasasJaPermissionsSearch.vue?vue&type=script&lang=js&"
export * from "./ipasasJaPermissionsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports